import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { DELETE, GET, POST } from "../../utils/api";
import { API } from "../../endpoints/common_endpoints";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";

// Thunk for getting all CARTS
export const getAllWalletHistory = createAsyncThunk(
  "get-all-wallet",
  async (_, { rejectWithValue }) => {
    try {
      const response = await GET(API.WALLET);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Thunk for posting CART
export const postAddMoney = createAsyncThunk(
  "post-cart",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(API.WALLET, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const postAddWithDraw = createAsyncThunk(
  "post-withdraw",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await POST(`${API.WALLET}/withdraw-amount`, data);
      if (response.success) {
        return response;
      } else {
        return rejectWithValue(response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Create the slice
const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    allWalletHistory: [],
    storeInFav: false,
    error: null,
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllWalletHistory.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(getAllWalletHistory.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.allWalletHistory = action.payload?.data || [];
        console.log(
          "getAllWishlist Response payload in fulfilled case:",
          action.payload
        );
        console.log("State after fulfilled", state);
      })
      .addCase(getAllWalletHistory.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })

      .addCase(postAddMoney.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(postAddMoney.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(postAddMoney.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      })
      .addCase(postAddWithDraw.pending, (state) => {
        state.status = "loading";
        console.log("State after pending", state);
      })
      .addCase(postAddWithDraw.fulfilled, (state, action) => {
        state.status = "succeeded";
        console.log("Response payload in fulfilled case:", action.payload);
        console.log("State after fulfilled", state);
      })
      .addCase(postAddWithDraw.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
        console.log("State after rejected", state);
      });
  },
});

export default walletSlice.reducer;
